<template>
    <DynamicComponent :path="dynamicComponentPath"/>
</template>
<script>
    import { reactive, toRefs, computed, onMounted } from "vue";
    import { useStore } from "vuex";

    import { Enums } from "@/helpers/enums";
    import { appData, C } from "@/helpers/global";

    import DynamicComponent from "@/components/DynamicComponent.vue";
    import { StoreUser } from "@/store/constants";

    export default {
        name: "PartialView",
        components: {
            DynamicComponent,
        },
        props: {
            isChange: {
                type: String
            },
            path: {
                type: String,
                required: true,
            },
        },
        setup(props) {
            const store = useStore();

            const e = reactive({
                user: computed(() => { return store.getters[StoreUser.get]; }),
                dynamicComponentPath: computed(() => {
                    //var hierarchy  = e.callingComponentHierarchy();
                    let path = props.path;// || hierarchy;
                    path = path.replace("src/views/", "").replace(".vue", "");
                    return `views/_partials/${e.getBasePathName()}/${path}`;
                }),
                userType: computed(() => {
                    return C.Int(e.user.userType);
                }),
                isBuyPackage: computed(() => {
                    return C.Bool(e.user.isBuyPackage);
                }),
                //callingComponentHierarchy() {
                //    let parent = instance.parent;
                //    return parent.type.__file;
                //},
                getBasePathName() {
                    let basePath = "";
                    switch (e.userType) {
                        case Enums.USER_TYPE.NULL:
                            basePath = "default";
                            break;
                        case Enums.USER_TYPE.STUDENT:
                            basePath = "student";
                            if (e.isBuyPackage) {
                                basePath += "-package";
                            }
                            break;
                        case Enums.USER_TYPE.TEACHER:
                            basePath = "teacher";
                            break;
                        case Enums.USER_TYPE.INSTRUCTOR:
                            basePath = "instructor";
                            break;
                        case Enums.USER_TYPE.CANDIDATE:
                            basePath = "candidate";
                            if (e.isBuyPackage) {
                                basePath += "-package";
                            }
                            break;
                    }
                    return basePath;
                },
            });
            onMounted(() => { 
            });
            return { ...toRefs(e) };
        },
    };
</script>